export default __webpack_public_path__ + "static/media/dfsscan.dd7157d5.png";